const priceTypes = [
    {label: "Закуп", value: 1},
    {label: "Продажа", value: 2}
]

const storageTypes = [
    {label: "Склад реализации", value: 1},
    {label: "Склад для возврата", value: 2},
    {label: "Склад для резерва", value: 3}
]

const colors = ["#7dc006", "#23b7e5", "#845ade", "#f5b74a", "#e6533c", "#259782", "#0ca5e9", "#a855f7", "#f97315"]

export const constants = {
    colors,
    priceTypes,
    storageTypes,
    GROUP_TYPE_CATEGORY: 1,
    GROUP_TYPE_PRODUCT: 2,
    GROUP_TYPE_INVENTORY: 3,

    CAUSE_TYPE_REJECT: 1,
    CAUSE_TYPE_RETURN: 2,

    BRAND_TYPE_BRAND: 1,
    BRAND_TYPE_MANUFACTURER: 2,

    PRODUCT_PARAM_TYPE_PACKAGE: 1,
    PRODUCT_PARAM_TYPE_SEGMENT: 2,

    CATEGORY_TYPE_PRODUCT: 1,
    CATEGORY_TYPE_PHOTO_REPORT: 2,

    TYPE_ZIMZIM: 1,
    TYPE_TRADE: 2,
    TYPE_HR: 3,
    TYPE_LOOP: 4,

    QUALITY_HIGH: 1,
    QUALITY_UNDEFINED: 0,
    QUALITY_LOW: -1,
}
